import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import "./CircleRectIcon.style.scss";

const CircleRectIcon = ({
  color = "#ddd",
  label,
  fullLabel,
  min,
  max,
  bg_warning,
  cursor,
  exclamation_warning,
}) => {
  return (
    <div className="circle-rect-icon-holder">
      <div
        className={`circle-rect-icon ${bg_warning ? "color-error" : ""} `}
        data-tip={fullLabel}
        data-for={label}
        style={{
          cursor: cursor ? cursor : "pointer",
        }}
      >
        <div
          className="circle-rect-icon_circle"
          style={{ backgroundColor: color }}
        >
          {label}
        </div>
        <div
          className="circle-rect-icon_rect"
          style={{ backgroundColor: color }}
        >{`${
          min === 0 ? min.toFixed() : min < 1 ? min.toFixed(2) : min.toFixed()
        }-${
          max === 0 ? min.toFixed() : max < 1 ? max.toFixed(2) : max.toFixed()
        }`}</div>
        <ReactTooltip id={label} />
      </div>
      {exclamation_warning && (
        <i
          className="fa fa-exclamation-triangle"
          title={`There are no securities found for ${fullLabel}.`}
          style={{
            color: color,
          }}
        ></i>
      )}
    </div>
  );
};

CircleRectIcon.propTypes = {
  fullLabel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  bg_warning: PropTypes.bool,
};

export default CircleRectIcon;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/circleRectIcon/CircleRectIcon.jsx